import {useReducer} from "react";
import {
  userScheduleAccordionReducer,
  initialUserScheduleAccordionState,
} from "../reducers";

export function useUserScheduleAccordion({
  reducer = userScheduleAccordionReducer,
}: {
  reducer: typeof userScheduleAccordionReducer;
}) {
  const [state, dispatch] = useReducer(reducer, initialUserScheduleAccordionState);
  const toggleIndex = (index: number) => dispatch({type: "toggle_index", payload: index});
  return {openIndexes: state.openIndexes, toggleIndex};
}
